<app-mobile-app-prompt />
<router-outlet />
